import React from 'react';
import BaseComponent from './BaseComponent';
import ClientSelector from './ClientSelector.js';
//import UserSelector from './UserSelector.js';
import $ from 'jquery';
//import {setUsers} from '../actionCreators';

import { ScheduleComponent, Day, Week, Month, Inject, ViewsDirective, ViewDirective } from '@syncfusion/ej2-react-schedule';
import { L10n, setCulture, loadCldr } from '@syncfusion/ej2-base';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import locale from './scheduler-localized.json';
import numberingSystems from './numberingSystems.json';
import gregorian from './ca-gregorian.json';
import numbers from './numbers.json';
import timeZoneNames from './timeZoneNames.json';

L10n.load(locale);
loadCldr(numberingSystems, gregorian, numbers, timeZoneNames);
setCulture('es');

class Scheduler extends BaseComponent {

    loadOnConstructor(){
		this.clientSelectedCallback = this.clientSelectedCallback.bind(this);
		this.userSelectedCallback = this.userSelectedCallback.bind(this);
		this.editorTemplate = this.editorTemplate.bind(this);
		this.addClient = this.addClient.bind(this);
		this.addUser = this.addUser.bind(this);
		this.apiNewCallback = this.apiNewCallback.bind(this);
		this.apiDeleteCallback = this.apiDeleteCallback.bind(this);
		this.deleteAppointment = this.deleteAppointment.bind(this);
		this.getSchedules = this.getSchedules.bind(this);
		this.getAppointmentsCallback = this.getAppointmentsCallback.bind(this);
		this.transformSchedulesToAppointments = this.transformSchedulesToAppointments.bind(this);
		this.modifyAppointmentCallback = this.modifyAppointmentCallback.bind(this);
		this.initializeRefs = this.initializeRefs.bind(this);
		this.handleInputChanges = this.handleInputChanges.bind(this);
		this.removeEvent = this.removeEvent.bind(this);
		this.changeEvent = this.changeEvent.bind(this);
		this.createEvent = this.createEvent.bind(this);
		this.deleteFromSerie = this.deleteFromSerie.bind(this);
		this.changeFromSerie = this.changeFromSerie.bind(this);
		this.stringDateToExceptionDate = this.stringDateToExceptionDate.bind(this);
		this.createNewEvent = this.createNewEvent.bind(this);
		this.refresh = this.refresh.bind(this);
		this.onCreated = this.onCreated.bind(this);
		this.onActionComplete = this.onActionComplete.bind(this);
		this.onEventRendered = this.onEventRendered.bind(this);
		this.loadUsers = this.loadUsers.bind(this);
		this.toggleUserFilter = this.toggleUserFilter.bind(this);
		this.getUserColor = this.getUserColor.bind(this);
		this.renderUserFilter = this.renderUserFilter.bind(this);
		this.getCurrentUserId = this.getCurrentUserId.bind(this);

		this.scheduleObj = null;
		this.assignedUserSelected = null;

		this.state = { appointments: [], reload: false, users: [], selectedUserIds: [] };

		this.initializeRefs();
    }

	refresh(){
		this.setState(prevState => {
			return {
				...prevState,
				reload: true
			}
		}, () => this.setState({reload: false}))
	}

	initializeRefs(){
		this.clientSel = React.createRef();
		this.clientInput = React.createRef();
		this.userInput = React.createRef();

		this.clientInputValue = {};
		this.clientFromAppointment = false;
		this.userInputValue = {};
		this.deletedClient = false;

		this.statusSelected = false;
		this.frequency = false;
		this.repeatUntilDate = false;
		this.repeatTimesValue = false;
		this.repeatDate = React.createRef();
		this.repeatTimes = React.createRef();
		this.repeatOption1 = React.createRef();
		this.repeatOption2 = React.createRef();
		this.radioRepeatUntil = React.createRef();
		this.radioRepeatTimes = React.createRef();

	}

	getCurrentUserId(){
		const u = JSON.parse(localStorage.getItem('user'));
		return u?._id || null;
	}

	onCreated(){
		if(this.hasPrivilege(1001)){
			// Carga usuarios primero; cuando termina dispara getSchedules
			this.loadUsers();
		}else{
			this._loadCurrentRange();
		}
	}

	_loadCurrentRange(){
		if(this.scheduleObj){
			const dates = this.scheduleObj.getCurrentViewDates();
			if(dates && dates.length > 0){
				this.getSchedules(dates[0], dates[dates.length - 1]);
				return;
			}
		}
		const now = new Date();
		this.getSchedules(
			new Date(now.getFullYear(), now.getMonth(), 1),
			new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59)
		);
	}

	loadUsers(){
		const api = this.getApi();
		api.getUsers([{ name: 'limit', value: 9999 }], (response) => {
			if(response.status === 'OK'){
				const users = response.users || [];
				const selectedUserIds = users.map(u => u._id);
				this.setState({ users, selectedUserIds }, () => this._loadCurrentRange());
			}
		});
	}

	toggleUserFilter(userId){
		this.setState(prevState => {
			const was = prevState.selectedUserIds.includes(userId);
			return {
				selectedUserIds: was
					? prevState.selectedUserIds.filter(id => id !== userId)
					: [...prevState.selectedUserIds, userId]
			};
		}, () => {
			if(this.scheduleObj){
				const dates = this.scheduleObj.getCurrentViewDates();
				if(dates && dates.length > 0) this.getSchedules(dates[0], dates[dates.length - 1]);
			}
		});
	}

	getUserColor(userId){
		const PALETTE = ['#2563eb','#16a34a','#dc2626','#9333ea','#ea580c','#0891b2','#ca8a04','#db2777','#059669','#7c3aed'];
		const { users } = this.state;
		const idx = users.findIndex(u => String(u._id) === String(userId));
		if(idx >= 0 && users[idx].calendar_color) return users[idx].calendar_color;
		if(idx >= 0) return PALETTE[idx % PALETTE.length];
		const hash = parseInt(String(userId).slice(-4), 16) || 0;
		return PALETTE[hash % PALETTE.length];
	}

	onEventRendered(args){
		const userId = args.data && args.data.assigned_user;
		if(!userId) return;
		const color = this.getUserColor(userId);
		if(args.element){
			args.element.style.backgroundColor = color;
			args.element.style.borderColor = color;
		}
	}

	renderUserFilter(){
		const { users, selectedUserIds } = this.state;
		if(!this.hasPrivilege(1001) || users.length === 0) return null;
		const allSelected = selectedUserIds.length === users.length;
		const someSelected = selectedUserIds.length > 0 && !allSelected;
		return (
			<div style={{ display:'flex', alignItems:'center', marginBottom:'12px' }}>
				<button
					type="button"
					data-toggle="modal"
					data-target="#usersFilterModal"
					style={{
						display:'flex', alignItems:'center', gap:'10px',
						padding:'7px 16px', borderRadius:'8px',
						border:'1px solid #d1d5db',
						background:'#fff', cursor:'pointer',
						fontSize:'14px', fontWeight:500, color:'#374151',
						boxShadow:'0 1px 3px rgba(0,0,0,0.07)'
					}}>
					<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M9 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0 2c-4 0-7 2-7 3v1h14v-1c0-1-3-3-7-3zm5-9a3 3 0 0 1 0 6M14 15c2 0 4 1.3 4 2.5V18" stroke="#6b7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
					</svg>
					<span>Usuarios</span>
					<span style={{
						background: allSelected ? '#e5e7eb' : someSelected ? '#dbeafe' : '#fee2e2',
						color: allSelected ? '#6b7280' : someSelected ? '#1d4ed8' : '#dc2626',
						borderRadius:'12px', padding:'1px 8px', fontSize:'12px', fontWeight:600
					}}>
						{selectedUserIds.length}/{users.length}
					</span>
					{users.slice(0,5).map(u => (
						<span key={u._id} style={{
							width:'10px', height:'10px', borderRadius:'50%',
							backgroundColor: this.getUserColor(u._id),
							opacity: selectedUserIds.includes(u._id) ? 1 : 0.25,
							marginLeft:'-4px', border:'1px solid #fff'
						}}/>
					))}
					<svg width="12" height="12" viewBox="0 0 20 20" fill="#9ca3af" xmlns="http://www.w3.org/2000/svg">
						<path d="M5 7l5 5 5-5" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
					</svg>
				</button>
			</div>
		);
	}

	renderUsersModal(){
		const { users, selectedUserIds } = this.state;
		if(!this.hasPrivilege(1001)) return null;
		return (
			<div className="modal fade" id="usersFilterModal" tabIndex="-1" role="dialog" aria-labelledby="usersFilterModalLabel" aria-hidden="true">
				<div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth:'420px' }}>
					<div className="modal-content" style={{ borderRadius:'12px', border:'none', boxShadow:'0 20px 60px rgba(0,0,0,0.15)' }}>
						<div className="modal-header" style={{ borderBottom:'1px solid #f3f4f6', padding:'20px 24px 16px' }}>
							<h5 className="modal-title" id="usersFilterModalLabel" style={{ fontWeight:600, fontSize:'16px', color:'#111827' }}>
								Filtrar por usuario
							</h5>
							<button type="button" className="close" data-dismiss="modal" aria-label="Cerrar"
								style={{ fontSize:'20px', color:'#9ca3af', opacity:1 }}>
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div className="modal-body" style={{ padding:'8px 24px', maxHeight:'360px', overflowY:'auto' }}>
							{users.map(user => {
								const color = this.getUserColor(user._id);
								const on = selectedUserIds.includes(user._id);
								return (
									<div key={user._id}
										onClick={() => this.toggleUserFilter(user._id)}
										style={{
											display:'flex', alignItems:'center', gap:'14px',
											padding:'10px 12px', borderRadius:'8px', cursor:'pointer',
											background: on ? 'rgba(37,99,235,0.05)' : 'transparent',
											transition:'background 0.1s', marginBottom:'2px'
										}}>
										<span style={{
											width:'12px', height:'12px', borderRadius:'50%',
											backgroundColor: color, flexShrink:0,
											boxShadow:'0 0 0 3px '+(on ? color+'33' : 'transparent')
										}}/>
										<span style={{ flex:1, fontSize:'14px', color:'#1f2937', fontWeight: on ? 500 : 400 }}>
											{user.name}{user.lastname ? ' '+user.lastname : ''}
										</span>
										<div style={{
											width:'18px', height:'18px', borderRadius:'4px', flexShrink:0,
											border:'2px solid '+(on ? color : '#d1d5db'),
											backgroundColor: on ? color : 'transparent',
											display:'flex', alignItems:'center', justifyContent:'center',
											transition:'all 0.15s'
										}}>
											{on && <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
												<path d="M1 4l2.5 2.5L9 1" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
											</svg>}
										</div>
									</div>
								);
							})}
						</div>
						<div className="modal-footer" style={{ borderTop:'1px solid #f3f4f6', padding:'14px 24px', justifyContent:'space-between' }}>
							<div style={{ display:'flex', gap:'8px' }}>
								<button type="button" className="btn btn-sm btn-outline-secondary"
									style={{ borderRadius:'6px', fontSize:'13px' }}
									onClick={() => this.setState({ selectedUserIds: users.map(u => u._id) }, () => {
										if(this.scheduleObj){
											const dates = this.scheduleObj.getCurrentViewDates();
											if(dates && dates.length > 0) this.getSchedules(dates[0], dates[dates.length - 1]);
										}
									})}>
									Todos
								</button>
								<button type="button" className="btn btn-sm btn-outline-secondary"
									style={{ borderRadius:'6px', fontSize:'13px' }}
									onClick={() => this.setState({ selectedUserIds: [] }, () => {
										if(this.scheduleObj){
											const dates = this.scheduleObj.getCurrentViewDates();
											if(dates && dates.length > 0) this.getSchedules(dates[0], dates[dates.length - 1]);
										}
									})}>
									Ninguno
								</button>
							</div>
							<button type="button" className="btn btn-primary btn-sm" data-dismiss="modal"
								style={{ borderRadius:'6px', fontSize:'13px', paddingLeft:'20px', paddingRight:'20px' }}>
								Aplicar
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}

	onActionComplete(args){
		if(args.requestType === 'dateNavigate' || args.requestType === 'viewNavigate'){
			if(this.scheduleObj){
				const dates = this.scheduleObj.getCurrentViewDates();
				if(dates && dates.length > 0){
					this.getSchedules(dates[0], dates[dates.length - 1]);
				}
			}
		}
	}

	getSchedules(rangeStart, rangeEnd){
		const api = this.getApi();
		const apiParams = [
			{ name: 'populate_client', value: 1 },
			{ name: 'range_start', value: (rangeStart || new Date()).toISOString() },
			{ name: 'range_end', value: (rangeEnd || new Date()).toISOString() }
		];

		if(this.hasPrivilege(1001)){
			const { selectedUserIds } = this.state;
			if(selectedUserIds.length > 0){
				apiParams.push({ name: 'assigned_users', value: selectedUserIds.join(',') });
			}
			// Si ningún usuario seleccionado, no añadimos filtro → resultado vacío lo maneja el backend
		}else{
			apiParams.push({ name: 'byToken', value: 1 });
		}

		api.getSchedules(apiParams, this.getAppointmentsCallback);
	}

	getAppointmentsCallback(response){
		if(response.status === 'OK'){
			this.setState(prevState => {
			return {
				...prevState,
				appointments: this.transformSchedulesToAppointments(response.schedules)
			}
			},this.refresh);
		}else{
			alert("Se ha perdido la sesion");
		}
	}

	transformSchedulesToAppointments(schedules, singleObject){

		if(singleObject === true){
			schedules = [schedules];
		}

		let schs = schedules.map(sch => {

			const startTime = new Date(sch.start_date);
			const endTime = new Date(sch.end_date);
			const repeatUntil = sch.repeat_until !== undefined ? new Date(sch.repeat_until) : undefined;

			let RecurrenceRule = sch.frequency !== 'NONE' && sch.frequency !== undefined?"FREQ="+sch.frequency+";INTERVAL=1;":"";
			RecurrenceRule += sch.repeat_until?
				"UNTIL="+sch.repeat_until.replace(/[-:.]/g, '').replace('T','T').substring(0,15)+"Z;":"";
			RecurrenceRule += sch.repeat_times?"COUNT="+sch.repeat_times:"";

			return {
				Subject: sch.Subject?sch.Subject:sch.title,
				StartTime: sch.StartTime?sch.StartTime:startTime,
				EndTime: sch.EndTime?sch.EndTime:endTime,
				Description: sch.Description?sch.Description:sch.description,
				id: sch.id?sch.id:sch._id,
				status: sch.status,
				client: sch.client?sch.client:null,
				completeClient: sch.client?sch.client:null,
				frequency: sch.frequency?sch.frequency:'NONE',
				clientName: sch.client?sch.client.name+' '+sch.client.lastname:'',
				assigned_user: typeof sch.assigned_user === 'string'?sch.assigned_user:sch.assigned_user._id,
				RecurrenceRule: RecurrenceRule,
				RecurrenceException: /*'20220126T080000Z',*/ sch.exceptions?sch.exceptions:undefined,
				exceptions: sch.exceptions?sch.exceptions:undefined,
				repeatTimes: sch.repeat_times,
				repeatUntil: sch.repeat_until?repeatUntil:undefined
			}
		});
		
		if(singleObject){
			schs = schs[0];
		}

		return schs;
    }

    transformAppointmentToSchedule(originalAppointment){
		const client = (originalAppointment.client && originalAppointment.client !== 'undefined')
			? originalAppointment.client
			: null;

		return {
			title: originalAppointment.Subject,
			start_date: new Date(originalAppointment.StartTime).toISOString(),
			end_date: new Date(originalAppointment.EndTime).toISOString(),
			description: originalAppointment.Description,
			_id: originalAppointment.id,
			client,
			status: originalAppointment.status,
			assigned_user: originalAppointment.assigned_user
		};
    }

    clientSelectedCallback(clientSelected){
    	this.clientInputValue = clientSelected!== null?clientSelected.clients[0]:null;
    	this.deletedClient = this.clientInputValue === null?true:false;
    	this.clientInput.current.value = clientSelected!== null && this.clientInputValue?this.clientInputValue.name+' '+this.clientInputValue.lastname:'';
    }

    userSelectedCallback(){
	//TODO: Hay que dejar el usuario igual que el cliente, sin redux.
    	//this.clientInputValue = clientSelected.clients[0];
    	//this.clientInput.current.value = this.clientInputValue.name+' '+this.clientInputValue.lastname; 
    }

    addClient(){
    	this.clientSel.current.setCurrentSelection(this.clientFromAppointment);
	$("#client-selector-component").modal('toggle');
    }

    addUser(){
/*
	this.props.setUsers({
	    title: 'Seleccione usuario',
	    buttons: [
	    {shown: 'Aplicar', close: true, callback: this.userSelectedCallback, behaviour: 'main'},
	    {shown: 'Cerrar', close: true}
	    ]
	});

	$("#user-selector-component").modal('toggle');
*/
    }

    editorTemplate(props) {

    	const statusFieldsSource = { text: 'text', value: 'value' };

    	const statusTypeSource = [
		{text: "Planificado", value: 1},
		{text: "Finalizado", value: 2},
		{text: "Cancelado", value: 3}
    	    ];

		this.clientFromAppointment = props.client;

		this.assignedUserSelected = props.assigned_user || this.getCurrentUserId();

		const frequencyFields = { value: 'value', text: 'text' };
		const frequencyTypes = [
			{ text: 'Nunca', value: 'NONE' },
			{ text: 'Diario', value: 'DAILY' },
			{ text: 'Semanal', value: 'WEEKLY' },
			{ text: 'Mensual', value: 'MONTHLY' }

		  ];

		  let statusSelected = 0;
		  statusTypeSource.forEach((elem, index) => {
			if(elem.value === props.status ){
				statusSelected = index;
				this.statusSelected = elem.value;
			}
		  });

		  let frequencySelected = 0;
		  frequencyTypes.forEach((elem, index) => {
			if(elem.value === props.frequency ) frequencySelected = index;
		  });

		  const repeatVisibility = props.frequency === 'NONE' || props.frequency === undefined?'none':'';


	return (props !== undefined ? <table className="custom-event-editor" style={{ width: '100%', cellpadding: '5' }}><tbody>
		<tr><td className="e-textlabel">Título</td><td colSpan={4}>
		<input id="Summary" className="e-field e-input" type="text" name="Subject" style={{ width: '100%' }}/>
		</td></tr>
		<tr>
			<td className="e-textlabel">Cliente</td>
			<td><input ref={this.clientInput} id="clientName" type="text" className="e-field e-input" name="clientName" readOnly />
			<input id="client" type="hidden" name="client"/> </td>
			<td><button className="btn btn-primary" onClick={this.addClient} >{this.state.selectedClient?"Cambiar cliente":"Agregar cliente"}</button></td>
		</tr>
		{this.hasPrivilege(1001) && this.state.users.length > 0 && <tr>
			<td className="e-textlabel">Asignado a</td>
			<td colSpan={4}>
				<DropDownListComponent
					id="assigned_user"
					data-name="assigned_user"
					placeholder="Seleccionar usuario"
					fields={{ text: 'text', value: 'value' }}
					dataSource={this.state.users.map(u => ({ text: u.name+(u.lastname?' '+u.lastname:''), value: u._id }))}
					value={this.assignedUserSelected}
					change={this.handleInputChanges}
				/>
			</td>
		</tr>}
		<tr><td className="e-textlabel">Estado</td><td colSpan={4}>
		<DropDownListComponent id="status" placeholder='Elija estado' data-name="status"
			change={this.handleInputChanges} 
			fields={statusFieldsSource} 
			dataSource={statusTypeSource} 
			index={statusSelected} />
		</td></tr>
		<tr><td className="e-textlabel">Desde</td><td colSpan={4}>
		<DateTimePickerComponent step="15" format='dd/MM/yy hh:mm a' id="StartTime" data-name="StartTime" value={new Date(props.startTime || props.StartTime)} className="e-field"></DateTimePickerComponent>
		</td></tr>
		<tr><td className="e-textlabel">Hasta</td><td colSpan={4}>
		<DateTimePickerComponent step="15" format='dd/MM/yy hh:mm a' id="EndTime" data-name="EndTime" value={new Date(props.endTime || props.EndTime)} className="e-field"></DateTimePickerComponent>
		</td></tr>
		<tr><td className="e-textlabel">Se repite</td><td colSpan={4}>
			<DropDownListComponent id="frequency" placeholder='Elija frecuencia' 
				data-name="frequency" index={frequencySelected} change={this.handleInputChanges} 
				fields={frequencyFields} dataSource={frequencyTypes} 
			/>
		</td></tr>
		<tr ref={this.repeatOption1} style={{display: repeatVisibility}}>
			<td>
				<input ref={this.radioRepeatUntil} type="radio" value="Until" name="repeat_type" id="repeat_until" 
					onClick={this.handleInputChanges} checked={props.repeatUntil?true:undefined} 
				/>
				<label htmlFor="repeat_until" style={{marginLeft: '5px'}}>Hasta</label>
			</td>
			<td colSpan={4}>
				<DateTimePickerComponent change={this.handleInputChanges}
					ref={this.repeatDate} step="15" format='dd/MM/yy hh:mm a' id="repeat_until_date"
					data-name="RepeatUntilDate" value={new Date(props.repeatUntil || props.RepeatUntil)}>
				</DateTimePickerComponent>
			</td>
		</tr>
		<tr ref={this.repeatOption2} style={{display: repeatVisibility}}>
			<td>
				<input checked={props.repeatTimes?true:undefined} ref={this.radioRepeatTimes} type="radio" value="During" name="repeat_type" id="repeat_times" 
					onClick={this.handleInputChanges} 
				/>
				<label htmlFor="repeat_times" style={{marginLeft: '5px'}}>N&uacute;mero</label>
			</td>
			<td colSpan={3}>
				<input ref={this.repeatTimes} type="number" name="times" style={{width: '40px'}} 
					onChange={this.handleInputChanges} defaultValue={props.repeatTimes?props.repeatTimes:''} 
				/>
				
				<label style={{marginLeft: '5px'}}>veces</label>
			</td>
		</tr>

		<tr><td className="e-textlabel">Descripcion</td><td colSpan={4}>
		<textarea id="Description" className="e-field e-input" name="Description" rows={3} cols={50} 
		style={{ width: '100%', height: '60px !important', resize: 'vertical' }}></textarea>
		</td></tr></tbody></table> : <div></div>);
    }

	handleInputChanges(event){
		if(event.element){
			switch(event.element.id){
				case "frequency":
					this.frequency = event.value;
					if(event.value === 'NONE'){
						this.repeatOption2.current.style.display = 'none';
						this.repeatOption1.current.style.display = 'none';
					}else{
						this.repeatOption2.current.style.display = '';
						this.repeatOption1.current.style.display = '';

						this.repeatTimes.current.disabled = this.radioRepeatTimes.current.checked?false:true;
						this.repeatDate.current.enabled = this.radioRepeatUntil.current.checked?true:false;
					}
				break;
				case "repeat_until_date":
					this.repeatUntilDate = event.value;
					this.repeatTimesValue = false;
				break;
				case "status":
					this.statusSelected = event.value;
				break;
				case "assigned_user":
					this.assignedUserSelected = event.value;
				break;
				default:

			}
		}else if( event.target.name === 'repeat_type' ){
			if(event.target.id === 'repeat_until'){
				this.repeatTimes.current.disabled = true;
				this.repeatDate.current.enabled = true;
			}else{ //repeat_times
				this.repeatTimes.current.disabled = false;
				this.repeatDate.current.enabled = false;
			}
		}else if(event.target.name === 'times'){
			this.repeatTimesValue = parseInt(event.target.value);
			this.repeatUntilDate = false;
		}
	}

    dateToStringDate(date){
		return new Date(date).toISOString();
    }

    onActionBegin(args){
		switch(args.requestType){
			case "eventCreate":
				//args.addedRecords
					this.createEvent(args);
				break;
			case "eventChange":
				//args.changedRecords
				if(args.data.occurrence){
					this.changeFromSerie(args);
				}else{
					this.changeEvent(args);
				}
				break;
			case "eventRemove":
				//Cuando se elimina algo de una serie, nos llega en ChangedRecords
				if(args.data[0].occurrence){
					this.deleteFromSerie(args.changedRecords[0]);
				}else{
					//Cuando se elimina una cita unica es deletedRecords
					this.removeEvent(args.deletedRecords.length>0?args.deletedRecords:args.changedRecords);
				}
				break;
			default:
				break;
		}
    }

	changeFromSerie(appointments){
		//Hay que crear excepcion para el dia y crear nuevo evento
		//this.deleteFromSerie(appointments.data.parent, appointments.data.occurrence);
		this.deleteFromSerie(appointments.changedRecords[0], appointments.data.occurrence);
	}

	deleteFromSerie(appointment, eventToCreate){
		const api = this.getApi();
		
		//let objToWork = JSON.parse(JSON.stringify(appointment));
		//let appointmentToUpdate = JSON.parse(JSON.stringify(this.transformAppointmentToSchedule(appointment)));
		let appointmentToUpdate = {...this.transformAppointmentToSchedule(appointment)};
		
		let objToWork = {...appointmentToUpdate};

		appointmentToUpdate.exception = this.stringDateToExceptionDate(this.dateToStringDate(new Date(objToWork.start_date)));

		if(eventToCreate){
			this.setState(prevState => {
				return {
					...prevState,
						appointmentToUpdate,
						aditionalEventToCreate: eventToCreate
				}
			},api.updateSchedule(appointmentToUpdate, this.modifyAppointmentCallback));
		}else{
			this.setState(prevState => {
				return {
					...prevState,
						appointmentToUpdate
				}
			},api.updateSchedule(appointmentToUpdate, this.modifyAppointmentCallback));
		}
	}

	stringDateToExceptionDate(stringDate){
		let exceptionDate = stringDate.replace(/\s/, 'T');
		exceptionDate = exceptionDate.replace(/[:-]/g, '')+"Z";
		
		return exceptionDate;
	}

	createEvent(args){
		const api = this.getApi();
		let newRecord;
		if(this.state.aditionalEventToCreate && args === this.state.aditionalEventToCreate){
			newRecord = {...this.state.aditionalEventToCreate};
			this.setState(prevState => { const s = {...prevState}; delete s.aditionalEventToCreate; return s; });
		}else{
			newRecord = args.addedRecords ? args.addedRecords[0] : args;
		}

		const apiParams = {
			title: newRecord.Subject || '',
			start_date: this.dateToStringDate(newRecord.StartTime),
			end_date: this.dateToStringDate(newRecord.EndTime),
			description: newRecord.Description || '',
			status: this.statusSelected || 1,
			frequency: this.frequency || 'NONE',
			repeat_condition: this.frequency
				? (this.repeatTimesValue || this.repeatUntilDate || false)
				: false,
		};

		this.frequency = false;

		if(this.clientInputValue && this.clientInputValue._id) apiParams.client = this.clientInputValue._id;
		this.clientInputValue = {};

		if(this.assignedUserSelected) apiParams.assigned_user = this.assignedUserSelected;
		this.assignedUserSelected = null;

		api.newSchedule(apiParams, this.apiNewCallback);
	}

	changeEvent(args){
		const api = this.getApi();
		let modifiedRecord = this.transformAppointmentToSchedule(args.changedRecords[0]);

		const modifiedClone = JSON.parse(JSON.stringify(modifiedRecord));
		modifiedClone.client = this.deletedClient?undefined:this.clientInputValue && this.clientInputValue._id?this.clientInputValue:modifiedRecord.client;

		let cloneForApi = JSON.parse(JSON.stringify(modifiedRecord));

		if(typeof modifiedClone.client === 'string' || modifiedClone.client === null){
				const fullAppointment = this.state.appointments.filter(ap => {
				return ap.client == modifiedClone.client
			});

			if(fullAppointment[0]){
				modifiedClone.client = fullAppointment[0].completeClient;
			}

			cloneForApi.client = modifiedClone.client;
		}else{
			cloneForApi.client = this.deletedClient?undefined:modifiedClone.client._id?modifiedClone.client._id:undefined;
		}

		this.clientInputValue = {};

		this.setState(prevState => {
			return {
				...prevState,
					appointmentToUpdate: modifiedClone
			}
		},api.updateSchedule(cloneForApi, this.modifyAppointmentCallback));
	}

	removeEvent(records){
		const api = this.getApi();
		let recordToRemove = records[0];
		let removedClone = JSON.parse(JSON.stringify(recordToRemove));
		removedClone.client = this.clientInputValue._id?this.clientInputValue._id:recordToRemove.client;
		recordToRemove.client = this.clientInputValue._id?this.clientInputValue:recordToRemove.client;
		this.clientInputValue = {};

		this.setState(prevState => {
			return {
				...prevState,
					appointmentToDelete: removedClone
			}
		},api.deleteSchedule(recordToRemove.id, this.apiDeleteCallback));
	}

    modifyAppointmentCallback(response){
		let apps = this.state.appointments.map(ap => {
			return ap.id === this.state.appointmentToUpdate._id?this.transformSchedulesToAppointments(this.state.appointmentToUpdate,true):ap
		});
		this.setState(prevState => {
			return {
				...prevState,
				appointments: apps
			}
		},this.createNewEvent);
    }

	createNewEvent(){
		if(!this.state.aditionalEventToCreate) return;
		this.createEvent(this.state.aditionalEventToCreate);
	}

    apiNewCallback(response){
		if(response.status !== 'OK') return;

		let newAppointments = this.state.appointments;
		newAppointments.push(this.transformSchedulesToAppointments(response.schedule, true));

		// Syncfusion crea un evento temporal sin id; lo eliminamos para sustituirlo por el del backend
		newAppointments = newAppointments.filter(app => app.id !== undefined);

		this.setState(prevState => ({...prevState, appointments: newAppointments}), this.refresh);
    }
    
    apiDeleteCallback(response){
    	if(response.status === 'OK'){
			this.setState(prevState => {
					return {
						...prevState,
						appointments: this.deleteAppointment(this.state.appointments)
					}
			}, this.refresh);
		}
    }

    deleteAppointment(appointments){
		return appointments.filter(apn => {
			return apn.id !== this.state.appointmentToDelete.id
		});
    }

    render() {

    	return (
		<>
			{this.renderUserFilter()}
    		<ScheduleComponent
				ref={sc => { this.scheduleObj = sc; }}
				editorTemplate={this.editorTemplate.bind(this)}
				timezone='Europe/Madrid' locale='es' timeFormat='HH:mm'
    			eventSettings={{ dataSource: this.state.appointments }}
				actionBegin={this.onActionBegin.bind(this)}
				actionComplete={this.onActionComplete}
				created={this.onCreated}
				eventRendered={this.onEventRendered}
    			timeScale={{ enable: true, interval: 60, slotCount: 4 }}
				startHour='07:00' endHour='22:00'>
    		    <Inject services={[Day, Week, Month]}/>
    		    <ViewsDirective>
    			<ViewDirective option='Day' />
    			<ViewDirective option='Week' firstDayOfWeek='1' />
    			<ViewDirective option='Month' firstDayOfWeek='1' />
    		    </ViewsDirective>
    		</ScheduleComponent>
		<ClientSelector ref={this.clientSel} onClientSelected={this.clientSelectedCallback} />
		{this.renderUsersModal()}
		</>
        )
    }
}

export default Scheduler
